var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"copyright has-text-grey-light is-size-7"},[_c('strong',[_vm._v("©")]),_vm._v(" "+_vm._s(_vm.year)+" - "+_vm._s(_vm.brand)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }